import React from "react";
import Modal from "../../Modal";
import VideoPlayer from "../../VideoPlayer";

const ViewVideo = ({ setShowModal, videoData }) => {
  const hanldeClose = () => {
    setShowModal((prev) => ({
      ...prev,
      video: false,
    }));
  };
  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a className="CloseModal" onClick={hanldeClose}>
            ×
          </a>
          <figure>
            {/* <video
              key={videoData}
              src={videoData}
              controls
              controlsList="nodownload"
              autoPlay
              style={{
                width: "100%",
                height: "331px",
              }}
            /> */}
            <VideoPlayer
              url={videoData}
              divHeight="310px"
              divStyle={{
                height: "100%",
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                objectFit: "contain",
                zIndex: 1,
              }}
            />
          </figure>
        </div>
      </div>
    </Modal>
  );
};

export default ViewVideo;
